export default __webpack_public_path__ + "static/media/icon-get-started.3a5c4ecf.svg";